module.exports = function(app) {
    app.directive('claimsFormsLibrary', function() {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'claims.appTemplate.html/chmhom/directives/claimsFormsLibrary',


            scope: {},

            controller: ['$scope', 'coremetrics', '$cookies', 'brand', function($scope, coremetrics, $cookies, brand) {

				$scope.claimsFormsLibraryAccess = false;
				var claimsFormsLibraryBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp', 'de'];
	            var claimsBrandCode = brand.current.sharedBrandCode.toLowerCase();
	            if (claimsFormsLibraryBrands.indexOf(claimsBrandCode) > -1) {         
	                $scope.claimsFormsLibraryAccess = true;
	            }

            }]
        };
    });
}